/**
 * FormActions Component
 *
 * Action buttons row for forms. Supports back/submit pattern.
 */

import React from "react";
import { ActionButton } from "@/components/ui/buttons/ActionButton";
import styles from "./FormActions.module.css";

export interface FormActionsProps {
  /** Submit button label */
  submitLabel: string;
  /** Submit button icon */
  submitIcon?: "save" | "check" | "add" | "send";
  /** Submit handler */
  onSubmit: () => void;
  /** Whether submit is disabled */
  submitDisabled?: boolean;
  /** Back button label (shows back button if provided) */
  backLabel?: string;
  /** Back handler */
  onBack?: () => void;
  /** Test ID prefix */
  testIdPrefix: string;
}

export const FormActions: React.FC<FormActionsProps> = ({
  submitLabel,
  submitIcon = "save",
  onSubmit,
  submitDisabled = false,
  backLabel,
  onBack,
  testIdPrefix,
}) => {
  return (
    <div className={styles.formActions}>
      {backLabel && onBack && (
        <ActionButton
          label={backLabel}
          icon="chevronLeft"
          iconPosition="left"
          variant="secondary"
          onClick={onBack}
          data-testid={`${testIdPrefix}-back`}
        />
      )}
      <div className={styles.spacer} />
      <ActionButton
        label={submitLabel}
        icon={submitIcon}
        onClick={onSubmit}
        disabled={submitDisabled}
        data-testid={`${testIdPrefix}-submit`}
      />
    </div>
  );
};

FormActions.displayName = "FormActions";

export default FormActions;
